module.exports = __webpack_public_path__ + "img/infinity3.e3be467f.jpg";